import React from "react";
import play from '../../images/play.svg';

const Card = ({ Items, filter, isMobile }) => {
  return (
    <>
      {Items.map((Val) => {
        if(filter === 'Todos' || Val.categoria === filter) {
        return (
          <article className="CardFilterCol">
            <div className="CardFilter" key={Val.id}>
              <div className="CardFilter-play-content">
                <div className="CardFilter-play">
                  <a href=""><img src={play} /></a>
                </div>
                <figure className='CardFilter-image'>
                  <img src={`${isMobile ? Val.screenshotMobile : Val.screenshot}`} alt={Val.titulo} className="desktop" />  
                </figure>
              </div>
              <h4 className="CardFilter-titulo">{Val.titulo}</h4>
              <p><span className="CardFilter-formato">{Val.formato}</span> <span className="CardFilter-categoria">{Val.categoria}</span></p>
            </div>
          </article>
        )}
      })}
    </>
  );
};

export default Card;
